import i18n from 'i18next'
import * as yup from 'yup'

// import { NUMBER_AND_LATIN_AND_SYMBOLS_REGEXP } from '../../constants'
import { EmailInputSchema } from '../../schemes'

const emailSchema = EmailInputSchema.fields.email as yup.StringSchema

export const ContactUsSchema = yup.object().shape({
  email: yup.string().when('$isAuthorized', (isAuthorized, schema) => {
    return !isAuthorized[0] ? schema.concat(emailSchema) : schema
  }),
  message: yup
    .string()
    // .matches(
    //   NUMBER_AND_LATIN_AND_SYMBOLS_REGEXP,
    //   i18n.t(
    //     'fieldCanContainLatinLettersDigitsSpecialCharacters',
    //     'Field can contain Latin letters, digits and special characters !@#$%^&*()-_=+. as stated.',
    //   ) || '',
    // )
    .test(
      'len',
      i18n.t(
        'fieldMustContainBetween1And1000Symbols',
        'Field must contain between 1 and 1000 symbols.',
      ) || '',
      (val): boolean => !!val && val.length >= 1 && val.length <= 1000,
    )
    .required(i18n.t('thisFieldIsRequired', 'This field is required') || ''),
  relatedFeature: yup
    .string()
    .required(i18n.t('thisFieldIsRequired', 'This field is required') || ''),
  file: yup
    .mixed()
    .test(
      'fileSize',
      i18n.t(
        'contactUs.form.error.maximumSizeOfTheFileIs10Mb',
        'The maximum size of the file is 10Mb',
      ) || '',
      (value: unknown) => !value || (value as File).size <= 10 * 1024 * 1024,
    ),
})

export type ContactUsInput = yup.InferType<typeof ContactUsSchema> & {
  file?: File
}
